module.exports = __webpack_public_path__ + "static/media/OfferBook_ios_2.3759a079.jpg";